import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { ReactComponent as OpenLinkIcon } from 'assets/icons/OpenLinkIcon.svg';

import { ROUTES } from 'constants/routes';
import { useStyles } from '../styles';
import { useAppSelector } from 'modules/state-mgmt/store';

const WorkerStatusHeader: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { projectName } = useAppSelector(state => ({
    projectName: state.cache?.project?.name,
  }));

  const handleMyProjectsClick = () => {
    navigate(ROUTES.SELECT_PROJECT.path);
  };

  return (
    <Box className={classes.header} data-testid="worker-status-header">
      <div className={classes.headerTitleContainer}>
        <p className={classes.title} data-testid="worker-status-title">
          {t('workerStatus.title')}
        </p>
        <p className={classes.projectName} data-testid="worker-status-project-name">
          {projectName}
        </p>
      </div>
      <Box className={classes.headerActions}>
        <div
          className={classes.actionButtonContainer}
          data-testid="worker-status-select-project-button"
          onClick={handleMyProjectsClick}
        >
          <OpenLinkIcon />
          <p className={classes.actionButton}>{t('workerStatus.actions.selectProject')}</p>
        </div>
      </Box>
    </Box>
  );
};

export default WorkerStatusHeader;
